import { FC } from 'react'
import { useForm, FormProvider, FormProviderProps, useFormContext } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import { ParserOptionsSchema, TParserOptionsSchema } from './ParserOptionsSchema'

/**
 * "This form is used for Edi Self Service Parser Options"
 */

export const useParserOptionsForm = () => {
  return useForm<TParserOptionsSchema>({
    resolver: yupResolver(ParserOptionsSchema),
    mode: 'onChange',
  })
}

export const ParserOptionsFormProvider: FC<FormProviderProps<TParserOptionsSchema>> = FormProvider

export const useParserOptionsFormContext = () => useFormContext<TParserOptionsSchema>()
